<template>
    <div class="app-container">
      <div class="layout-container">
        <!-- 左侧内容区域 -->
        <div class="left-panel">
          <!-- 基本信息表格 -->
          <div class="info-section">
            <MyTitle title="基本信息" :mt0="true" />
            <el-descriptions :column="2" border style="width: 100%">
              <el-descriptions-item label="投诉编号" label-align="right" align="left" :span="2">{{ logIdList.complaintCode || '-' }}</el-descriptions-item>
              <el-descriptions-item label="企业名称" label-align="right" align="left" :span="2">{{ logIdList.comName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="所属单位" label-align="right" align="left" :span="2">{{ logIdList.streetName || '-' }}</el-descriptions-item>
              <el-descriptions-item label="投诉人姓名" label-align="right" align="left" :span="1">{{ logIdList.userName || logIdList.userId || '-' }}</el-descriptions-item>
              <el-descriptions-item label="联系方式" label-align="right" align="left" :span="1">{{ logIdList.userPhone || logIdList.phone || '-' }}</el-descriptions-item>
              <el-descriptions-item label="欠薪金额" label-align="right" align="left" :span="2">{{ logIdList.arrearsAmount || '-' }}<span v-if="logIdList.arrearsAmount">元</span></el-descriptions-item>
              <el-descriptions-item label="欠薪期间" label-align="right" align="left" :span="2">{{ logIdList.wageArrearsStart || '-' }} <span style="margin: 0 6px">至</span> {{ logIdList.wageArrearsEnd || '-' }}</el-descriptions-item>
              <el-descriptions-item label="备注/补充说明" label-align="right" align="left" :span="2">{{ logIdList.complaintExplain || logIdList.remarks || '-' }}</el-descriptions-item>
              <el-descriptions-item label="附件" label-align="right" align="left" :span="2">
                <MyFileList :fileList="getFileListForDisplay(logIdList)" :columns="7"></MyFileList>
              </el-descriptions-item>
            </el-descriptions>
          </div>
  
          <!-- 处理表单 -->
          <div class="form-section">
            <div class="section-title">结案审核</div>
            <el-form ref="formRef" :model="form" :label-position="'top'" :label-width="'auto'">
              <el-form-item label="审核说明">
                <el-input type="textarea" v-model="form.caseExplain" placeholder="请输入结案审核说明" :rows="4"></el-input>
              </el-form-item>
              <el-form-item label="结案状态">
                <el-select v-model="form.auditCaseStatus" placeholder="请选择结案状态" style="width: 100%">
                  <el-option label="结案" value="0">结案</el-option>
                  <el-option label="退回" value="1">退回</el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button size="large" @click="handleBack">取消</el-button>
                <el-button type="primary" @click="submitForm">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
  
        <!-- 右侧内容区域 -->
        <div class="right-panel">
          <div class="section-title">处置信息</div>
          <div class="steps-container">
            <MyTimeLine :cardList="timelineData" :complaintInfo="logIdList" @handleUpdateData="handleUpdateData" />
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {getEnterpriseDetail, getRecodList, submitCase} from "@/api/unpaidWages/enterprise";
  import { notifySuccess } from '@/utils/modal'
  import MyTimeLine from '@/components/myComponents/MyTimeLine/index.vue'
  import MyTitle from '@/components/myComponents/MyTitle/index.vue'
  import MyFileList from '@/components/myComponents/MyFileList/index.vue'

  export default {
    name: 'ComplaintOperation',
    components: {
      MyTimeLine,
      MyTitle,
      MyFileList
    },
    data() {
      return {
        id: '0',
        logIdList: {},
        activeStep: 1,
        timelineData: [],
        form: {
          caseExplain: '',
          auditCaseStatus: '',
        }
      }
    },
    mounted() {
      // 从store中获取id
      this.id = this.$store.state.enterprise.currentId;
      // 使用这个id进行后续操作
      console.log(this.id);
      this.getDisposalInfo();
      this.getTimeLineData();
    },
    methods: {
      
      handleBack() {
        // 这里可以添加取消逻辑，比如返回上一页
        this.form.auditCaseStatus = '';
        this.form.caseExplain = '';
        this.$router.push({
          path: '/laborRelations/enterprise/complaint',
        });
      },
      
      // 提交方法
      async submitForm() {
        try {
          // 构建提交数据

          const submitData = {
            id: this.id,
            auditCaseStatus: this.form.auditCaseStatus,
            caseExplain: this.form.caseExplain,
          };
          const res = await submitCase(submitData);
          if (res.data) {
            notifySuccess('提交成功');
            // 可以在这里添加跳转逻辑
            this.$router.push({
              path: '/laborRelations/enterprise/complaint',
            });
          }
        } catch (error) {
          console.log('表单验证失败');
          return false;
        }
      },
      
      // 获取投诉详情
      async getDisposalInfo() {
        const res = await getEnterpriseDetail({id: this.id});
        this.logIdList = res.data;
        // 根据实际数据设置步骤状态
        if (this.logIdList.processStatus === 2) {
          this.activeStep = 4;
        } else if (this.logIdList.processStatus === 1) {
          this.activeStep = 3;
        } else if (this.logIdList.dispatchStatus === 1) {
          this.activeStep = 2;
        } else {
          this.activeStep = 1;
        }
      },
      
      // 获取时间线数据
      async getTimeLineData() {
        try {
          const res = await getRecodList({complaintId: this.id});
          this.timelineData = (res.data || []).map((item) => {
            return {
              ...item,
              fileList: !item.recordFileList || !item.recordFileList.length ? [] : item.recordFileList.map((file) => {
                if (typeof file === "object") return file;
                return {
                  fileName: file.split("/")[file.split("/").length - 1],
                  fileUrl: file,
                  path: file
                };
              })
            };
          });
        } catch (e) {
          console.log(e);
        }
      },
      
      // 更新数据
      handleUpdateData() {
        this.getDisposalInfo();
        this.getTimeLineData();
      },
      
      // 获取文件列表用于显示
      getFileListForDisplay(data) {
        if (!data) return [];
        
        // 优先使用 fileUrl（字符串格式）
        if (data.fileUrl) {
          return data.fileUrl;
        }
        
        // 如果有 attachments 数组
        if (data.attachments && Array.isArray(data.attachments) && data.attachments.length > 0) {
          return data.attachments.map(item => ({
            url: item.fileUrl || item.url || item.path,
            fileName: item.fileName || item.name
          }));
        }
        
        return [];
      }
    }
  }
  </script>
  
  <style scoped>
  .app-container {
    background: #f7f8f9;
    height: 100vh;
    overflow: hidden;
    padding: 20px;
  }

  .layout-container {
    display: flex;
    height: calc(100vh - 40px);
  }
  
  .layout-container > * {
    margin-right: 20px;
  }
  
  .layout-container > *:last-child {
    margin-right: 0;
  }

  .left-panel {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }

  .right-panel {
    width: 450px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .info-section,
  .form-section,
  .right-panel {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  .info-section {
    margin-bottom: 20px;
  }

  .form-section {
    flex: 1;
  }

  .right-panel {
    overflow-y: auto;
  }

  .section-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #eaeaea;
  }

  /* 使用 el-descriptions 的样式 */
  /deep/ .el-descriptions__label {
    width: 120px;
    background-color: rgb(237, 246, 252) !important;
  }
  
  /deep/ .el-descriptions__content {
    background-color: rgb(249, 250, 251) !important;
  }

  .steps-container {
    padding: 10px 0;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  ::v-deep .el-step__description {
    font-size: 14px;
    line-height: 1.5;
  }

  .uploaded-files {
    display: flex;
    flex-wrap: wrap;
  }
  
  .uploaded-files > * {
    margin-right: 15px;
    margin-bottom: 15px;
  }
  
  .uploaded-files > *:last-child {
    margin-right: 0;
  }

  .img-up {
    width: 110px;
    height: 110px;
    position: relative;
    padding-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .fileIcon {
    width: 60px;
    height: 60px;
    background-image: url("~@/assets/generalFile.png");
    background-size: cover;
  }

  .close-icon {
    position: absolute;
    right: 5px;
    top: 5px;
    z-index: 99;
    cursor: pointer;
  }

  .full-width-upload {
    width: 100%;
  }

  .full-width-upload ::v-deep .el-upload {
    width: 100%;
  }

  .full-width-upload ::v-deep .el-upload-dragger {
    width: 100%;
  }
  
  .el-text {
    display: inline-block;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  </style>
